import React, {Component} from 'react';
import { connect } from 'react-redux';
import {FormattedMessage} from "react-intl";
import {setFilterActionQuestions} from 'scenes/Survey/Structure/actions';
import {Button, Tooltip} from "reactstrap";

class ButtonFilterActionQuestions extends Component {

  constructor(props) {
    super(props);

    this.state = {
      tooltip: false,
      filterActionQuestions: props.filterActionQuestions,
    };

    this.toggleFilterActionQuestions = this.toggleFilterActionQuestions.bind(this);
    this.toggleTooltip = this.toggleTooltip.bind(this);
  }

  toggleFilterActionQuestions() {
    this.setState({filterActionQuestions: !this.state.filterActionQuestions}, () => {
      this.props.setFilterActionQuestions(this.state.filterActionQuestions);
    })
  }

  toggleTooltip() {
    this.setState({tooltip: !this.state.tooltip})
  }

  render() {
    return (
      <Button className="mb-0" id="buttonFilterActionQuestions" color={this.state.filterActionQuestions ? 'primary' : 'secondary'} onClick={this.toggleFilterActionQuestions}>
        <i className="fas fa-exclamation"/>
        <Tooltip
          delay={0}
          placement="bottom"
          isOpen={this.state.tooltip}
          target="buttonFilterActionQuestions"
          toggle={this.toggleTooltip}
        >
          <FormattedMessage id="topbar.advancedOptions.filterActionQuestions.label"/>
        </Tooltip>
      </Button>
    )
  }
}

function mapStateToProps(state) {
  return {
    filterActionQuestions: state.survey.structure.filterActionQuestions,
  }
}

export default connect(mapStateToProps, {setFilterActionQuestions})(ButtonFilterActionQuestions);
